import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function ProductSummaryCard() {
  return <section className="max-w-lg mx-auto px-4 pb-6 animate-fade-in-up" data-id="element-78">
      <div className="bg-almond-milk rounded-2xl p-5 shadow-sm" data-id="element-79">
        <div className="flex gap-4" data-id="element-80">
          {/* Product Image */}
          <div className="flex-shrink-0" data-id="element-81">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m4yThtScr4RZyGecczd1NM/Untitled_design_%2862%29.png" alt="Guía TikTok Shop" className="w-24 h-32 object-cover rounded-lg shadow-md" data-id="element-82" />
          </div>

          {/* Product Info */}
          <div className="flex-1" data-id="element-83">
            <h2 className="text-base font-semibold text-deep-cocoa mb-2 leading-tight" data-id="element-84">
              GANA $500 MXN DIARIOS CON TIKTOK SHOP
            </h2>
            <p className="text-xs text-deep-cocoa/70 mb-3" data-id="element-85">
              La Guía Oficial Para Mujeres Mexicanas
            </p>

            {/* Benefits */}
            <div className="space-y-1.5" data-id="element-86">
              <div className="flex items-start gap-2" data-id="element-87">
                <CheckCircle2Icon className="w-4 h-4 text-champagne-gold flex-shrink-0 mt-0.5" data-id="element-88" />
                <span className="text-xs text-deep-cocoa/80" data-id="element-89">
                  Acceso inmediato digital
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-90">
                <CheckCircle2Icon className="w-4 h-4 text-champagne-gold flex-shrink-0 mt-0.5" data-id="element-91" />
                <span className="text-xs text-deep-cocoa/80" data-id="element-92">
                  Solo necesitas tu celular
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-93">
                <CheckCircle2Icon className="w-4 h-4 text-champagne-gold flex-shrink-0 mt-0.5" data-id="element-94" />
                <span className="text-xs text-deep-cocoa/80" data-id="element-95">
                  Pago único, sin mensualidades
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-96">
                <CheckCircle2Icon className="w-4 h-4 text-champagne-gold flex-shrink-0 mt-0.5" data-id="element-97" />
                <span className="text-xs text-deep-cocoa/80" data-id="element-98">
                  Guía completa paso a paso
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Price */}
        <div className="mt-4 pt-4 border-t border-deep-cocoa/10 flex items-center justify-between" data-id="element-99">
          <span className="text-sm font-medium text-deep-cocoa/70" data-id="element-100">
            Total a pagar:
          </span>
          <span className="text-2xl font-bold text-deep-cocoa" data-id="element-101">$190 MXN</span>
        </div>

        <p className="text-xs text-center text-deep-cocoa/60 mt-3" data-id="element-102">
          Pagas una sola vez. Recibes acceso inmediato a la guía completa.
        </p>
      </div>
    </section>;
}